import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  notificationSchedule: association('default'),

  name: () => faker.lorem.words(),
  address: () => faker.location.streetAddress(),
  city: () => faker.location.city(),
  state: () => faker.location.state(),
  zip: () => faker.location.zipCode(),

  addressLineOne: null,
  createdAt: () => new Date(),
  enabled: true,
  latitude: null,
  locationName: undefined,
  longitude: null,
  notificationTemplateBody: undefined,
  notificationTemplateSubject: undefined,
  requireSignature: false,
  timeZone: 'America/Los_Angeles',

  afterCreate(deliveryArea, server) {
    const notificationConfig = server.schema.notificationConfigs.find(deliveryArea.locationId);

    if (!notificationConfig) {
      server.create('notification-config', { location: deliveryArea.location });
    }
  },
});
